const STORAGE_KEY = "minenebtc-preferences";

export const hasSavedPreferences = () => localStorage.getItem(STORAGE_KEY) !== null;

export const DEFAULT_PREFERENCES = {
  timezone: "America/Santo_Domingo",
  date_format: "DD/MM/YYYY",
  time_format: "24h",
  theme: "light",
};

export function getPreferences() {
  try {
    return { ...DEFAULT_PREFERENCES, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") };
  } catch {
    return { ...DEFAULT_PREFERENCES };
  }
}

export function savePreferences(next) {
  const preferences = { ...getPreferences(), ...next };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  applyTheme(preferences.theme);
  return preferences;
}

export function applyTheme(theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
}

const dateTimeParts = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  return Object.fromEntries(parts.map((part) => [part.type, part.value]));
};

export function dateTimeInputForZone(date = new Date(), timeZone = getPreferences().timezone) {
  const parts = dateTimeParts(date, timeZone);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function dateInputForZone(date = new Date(), timeZone = getPreferences().timezone) {
  const parts = dateTimeParts(date, timeZone);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function monthInputForZone(date = new Date(), timeZone = getPreferences().timezone) {
  const parts = dateTimeParts(date, timeZone);
  return `${parts.year}-${parts.month}`;
}

export function zonedDateTimeToIso(value, timeZone = getPreferences().timezone) {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!match) return new Date(value).toISOString();
  const [, year, month, day, hour, minute] = match.map(Number);
  const wallTime = Date.UTC(year, month - 1, day, hour, minute);
  const offsetAt = (timestamp) => {
    const parts = dateTimeParts(new Date(timestamp), timeZone);
    return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second)) - timestamp;
  };
  let timestamp = wallTime - offsetAt(wallTime);
  timestamp = wallTime - offsetAt(timestamp);
  return new Date(timestamp).toISOString();
}

applyTheme(getPreferences().theme);
